<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">到期提醒</div>
    </div>
    <div class="modul-content">
      <!-- 查询 -->
      <div class="query-form">
        <el-form :inline="true" :model="form" ref="form">
          <el-form-item label="桥梁名称">
            <el-select
              v-model="bridgeUuid"
              @change="bridgeChange"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in bridgeData"
                :key="index"
                :label="item.bridgeName"
                :value="item.bridgeUuid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select
              v-model="equipmentType"
              @change="equipmentTypeChange"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in equipmentTypes"
                :key="index"
                :label="item.equipmentName"
                :value="item.equipmentName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="tableReq(1)">查询</el-button>
          </el-form-item>
        </el-form>
        <el-form :inline="true">
          <el-form-item>
            <el-button @click="update">新增</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button 
                       @click="onExport">导出</el-button>
          </el-form-item> -->
        </el-form>
      </div>
      <el-table
        class="tableStyle"
        v-loading="loading"
        height="calc(100vh - 350px)"
        border
        style="width: 100%"
        :data="tableData"
        :header-cell-style="{background: '#FAFAFA', color: '#000000'}"
      >
        <el-table-column
          label="序号"
          align="left"
          type="index"
          width="50px"
        ></el-table-column>
        <el-table-column
          prop="bridgeName"
          label="桥梁"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="equipmentName"
          label="设备名称"
          align="left"
        ></el-table-column>
        <el-table-column label="保质期" align="left">
          <template #default="scope">
            <div class="warning-value" style="justify-content: flex-start">
              <div id="">
                {{ scope.row.guaranteePeriodStart }}
              </div>
              <div class="input-line">至</div>
              <div id="">
                {{ scope.row.guaranteePeriodEnd }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="inspectionDate"
          label="季度巡检日期"
          align="left"
        >
        </el-table-column>
        <el-table-column prop="status" label="操作" align="left">
          <template #default="scope">
            <div>
              <el-button type="text" @click="update(scope.row)">操作</el-button>
              <el-button type="text" @click="del(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--  -->
    <div style="text-align: center; margin: 20px 0 0">
      <!--描述：分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.pageNum"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]"
        :page-size="form.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 点击处理弹出框 -->
    <div class="caozuotianbiao" :style="addmod == true ? 'display: none;' : ''">
      <el-form
        class="caozuotianbiao-from"
        label-width="90px"
        label-position="right"
        :rules="rules"
        ref="dispose"
        style="
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          align-content: center;
        "
      >
        <div class="modul-top" style="position: absolute; top: 5px">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">到期提醒</div>
        </div>
        <div
          class="caidan-img"
          style="
            position: absolute;
            top: 15px;
            right: 15px;
            border-radius: 50%;
            overflow: hidden;
            width: 30px;
            height: 30px;
          "
          @click="quxiao"
        >
          <img
            src="../../../assets/image/old/删除@2x.png"
            alt="关闭"
            style="width: 100%; height: 100%"
          />
        </div>
        <el-row style="margin-top: 40px">
          <el-col :span="11">
            <el-form-item label="桥梁名称" prop="bridgeUuid">
              <el-select
                v-model="dispose.bridgeUuid"
                @change="bridgeChanges"
                filterable
                clearable
                placeholder="请选择桥梁"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in bridgeDatas"
                  :key="index"
                  :label="item.bridgeName"
                  :value="item.bridgeUuid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="设备名称" prop="equipmentUuid">
              <el-select
                v-model="equipmentUuid"
                @change="equipmentTypeChanges"
                filterable
                clearable
                placeholder="请选择设备"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in equipmentTypess"
                  :key="index"
                  :label="item.equipmentName"
                  :value="item.equipmentUuid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="保质期" style="width: 100%">
              <el-date-picker
                v-model="time"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="timeChange"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="季度巡检日期" style="width: 100%">
              <el-date-picker
                v-model="inspectionDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期时间"
                @change="timeChanges"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="position: absolute; bottom: 0; right: 15px">
          <el-button type="primary" @click="isOK">确定</el-button>
          <el-button @click="quxiao">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeqingBridgeAndTunnelShebeiliebiao',

  data() {
    return {
      form: {
        bridgeName: '',
        equipmentName: '',
        pageNum: 1,
        pageSize: 10
      },
      dispose: {
        bridgeName: '',
        bridgeUuid: '',
        createName: '',
        createUuid: '',
        equipmentName: '',
        equipmentUuid: '',
        guaranteePeriodEnd: '',
        guaranteePeriodStart: '',
        inspectionDate: ''
      },
      time: '',
      equipmentUuid: '',
      inspectionDate: '',
      rules: {
        bridgeUuid: [
          {
            required: true,
            message: ' ',
            trigger: 'change'
          }
        ],
        equipmentUuid: [
          {
            required: true,
            message: ' ',
            trigger: 'change'
          }
        ]
      },
      loading: false,
      tableData: [],
      total: 0,
      bridgeData: [],
      bridgeDatas: [],
      equipmentTypes: [],
      equipmentTypess: [],
      equipmentType: '',
      bridgeName: '',
      bridgeUuid: '',
      addmod: true, //修改新增表单显示隐藏
      userInfo: []
    }
  },

  mounted() {
    this.getBiBridgeBoPage()
    this.tableReq()
    this.userInfo = JSON.parse(JSON.stringify(this.$store.state.userintfo))
  },

  methods: {
    async tableReq(page) {
      this.loading = true
      if (this.bridgeData && this.bridgeData.length > 0) {
        if (this.bridgeUuid != '') {
          let add = this.bridgeData.find((item) => {
            return this.bridgeUuid == item.bridgeUuid
          })
          console.log(add)
          this.form.bridgeName = add.bridgeName
        } else {
          this.form.bridgeName = ''
        }
      }
      console.log(this.form)
      this.loading = false
      const res = await this.$api.sendPost(
        '/biExpirationReminder/getBiExpirationReminder',
        this.form
      )
      console.log(res)
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.tableData = res.data.list
        } else {
          this.tableData = []
        }
      }
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.form.pageSize = val
      this.tableReq(1)
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.form.pageNum = val
      this.tableReq()
    },
    // 设备类型选择
    async equipmentTypeChange(e) {
      // this.equipmentTypeUuid = e;
      console.log(e)
      this.form.equipmentName = e
    },
    async equipmentTypeChanges(e) {
      // this.equipmentTypeUuid = e;
      console.log(e)
      this.dispose.equipmentUuid = e
      if (this.dispose.equipmentUuid != '') {
        let adds = this.equipmentTypess.find((item) => {
          return this.dispose.equipmentUuid == item.equipmentUuid
        })
        console.log(adds)
        this.dispose.equipmentName = adds.equipmentName
        console.log(this.dispose)
      } else {
        this.dispose.equipmentName = ''
      }
      console.log(this.dispose)
      console.log(this.equipmentTypess)
      // this.dispose.equipmentUuid = e
    },
    // 获取-桥梁名称列表
    async getBiBridgeBoPage() {
      let data = {
        pageSize: 99999,
        pageNum: 1
      }
      const res = await this.$api.sendPost('/biBridge/getBiBridgeBoPage', data)
      console.log('桥梁名称', res)
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.bridgeData = res.data.list
          this.bridgeDatas = res.data.list
        } else {
          this.bridgeData = []
          this.bridgeDatas = []
        }
      }
    },
    // 桥梁名称选择
    async bridgeChange(e) {
      // this.bridgeUuid = e;
      this.equipmentType = ''
      const res = await this.$api.sendGet(
        '/biBridge/getEquipmentByBiBridgeAndEquipmentTypeUuid',
        {
          bridgeUuid: e
        }
      )
      console.log('设备类型', res)
      if (res.errcode === 0) {
        this.equipmentTypes = res.data
        this.equipmentType = ''
      } else {
        this.equipmentTypes = []
        this.equipmentType = ''
      }
    },
    async bridgeChanges(e) {
      console.log('修改设备')
      // this.bridgeUuid = e;
      this.equipmentUuid = ''
      this.equipmentTypess = []
      const res = await this.$api.sendGet(
        '/biBridge/getEquipmentByBiBridgeAndEquipmentTypeUuid',
        {
          bridgeUuid: e
        }
      )
      console.log('设备类型', res)
      if (res.errcode === 0) {
        this.equipmentTypess = res.data
      } else {
        this.equipmentTypess = []
      }
    },
    //新增和操作
    async update(data) {
      this.addmod = false
      console.log(data)
      if (data.id != undefined) {
        this.dispose = data
        this.time = [data.guaranteePeriodStart, data.guaranteePeriodEnd]
        this.inspectionDate = data.inspectionDate
        this.equipmentUuid = data.equipmentName
        console.log(this.dispose)
        const res = await this.$api.sendGet(
          '/biBridge/getEquipmentByBiBridgeAndEquipmentTypeUuid',
          {
            bridgeUuid: data.bridgeUuid
          }
        )
        console.log('设备类型', res)
        if (res.errcode === 0) {
          this.equipmentTypess = res.data
        } else {
          this.equipmentTypess = []
        }
      } else {
        this.dispose = {
          bridgeName: '',
          bridgeUuid: '',
          createName: '',
          createUuid: '',
          equipmentName: '',
          equipmentUuid: '',
          guaranteePeriodEnd: '',
          guaranteePeriodStart: '',
          inspectionDate: ''
        }
        this.time = []
        this.inspectionDate = ''
        this.dispose.equipmentName = ''
        this.dispose.equipmentUuid = ''
        this.equipmentUuid = ''
      }
      console.log(this.dispose)
    },
    //操作按钮
    operate(data) {},
    async isOK() {
      console.log('确认修改', this.dispose)
      this.addmod = true
      if (this.bridgeDatas && this.bridgeDatas.length > 0) {
        if (this.dispose.bridgeUuid != '') {
          let add = this.bridgeData.find((item) => {
            return this.dispose.bridgeUuid == item.bridgeUuid
          })
          console.log(add)
          this.dispose.bridgeName = add.bridgeName
          console.log(this.dispose)
        } else {
          this.dispose.bridgeName = ''
        }
        if (this.dispose.equipmentUuid != '') {
          let adds = this.equipmentTypess.find((item) => {
            return this.dispose.equipmentUuid == item.equipmentUuid
          })
          console.log(adds)
          this.dispose.equipmentName = adds.equipmentName
          console.log(this.dispose)
        } else {
          this.dispose.equipmentName = ''
        }
      }
      this.dispose.createName = this.userInfo.accountName
      this.dispose.createUuid = this.userInfo.accountUuid
      console.log(this.dispose)
      const res = await this.$api.sendPost(
        '/biExpirationReminder/saveOrUpdate',
        this.dispose
      )
      console.log('状态', res)
      if (res.errcode === 0) {
        this.tableReq()
      } else {
      }
      this.dispose = {
        bridgeName: '',
        bridgeUuid: '',
        createName: '',
        createUuid: '',
        equipmentName: '',
        equipmentUuid: '',
        guaranteePeriodEnd: '',
        guaranteePeriodStart: '',
        inspectionDate: ''
      }
      this.time = ''
      this.equipmentUuid = ''
      this.inspectionDate = ''
    },
    quxiao() {
      console.log('取消')
      this.addmod = true
    },
    //删除
    async del(data) {
      console.log(data.id)
      const res = await this.$api.sendGet('/biExpirationReminder/delete', {
        id: data.id
      })
      this.tableReq()
    },
    timeChange(e) {
      console.log(e)
      let time = JSON.parse(JSON.stringify(e))
      console.log(time)
      if (time.length > 0) {
        this.dispose.guaranteePeriodStart = time[0]
        this.dispose.guaranteePeriodEnd = time[1]
      } else {
        this.dispose.guaranteePeriodStart = ''
        this.dispose.guaranteePeriodEnd = ''
      }
    },
    timeChanges(e) {
      console.log(e)
      this.dispose.inspectionDate = e
    }
  }
}
</script>

<style lang="scss" scoped>
.zhuangtai {
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-value {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.el-menu-vertical-demo {
  height: 600px;
}

.caozuotianbiao {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.caozuotianbiao-from {
  position: relative;
  text-align: left;
  width: 70%;
  height: 70%;
  background-color: #fff;
  padding: 20px;
}
</style>
